import { EPaymentBrand } from './enum'

export class Channel {
  id: string
  chanCode: EPaymentBrand // æ¸ éä»£ç 
  paymentBrand: EPaymentBrand // æ¯ä»åç
  chanMerID: string // æ¸ éåæ·å·ï¼æ¯ä»å®ï¼PIDï¼
  chanMerName: string // æ¸ éåæ·åç§°
  version: number // çæ¬
}

export interface IChannelQueryParams {
  chanCode?: EPaymentBrand
  chanMerId?: string // æ¸ éåæ·å·ï¼æ¯ä»å®ï¼PIDï¼
  chanMerName?: string // æ¸ éåæ·åç§°
  keyword?: string
  page: number
  size: number
}
